/* Vendored shadcn/ui. 110 §8: loading is a skeleton in the shape of what is coming,
   never a spinner. A spinner tells you nothing. */
import { cn } from '@/lib/utils';

export function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-[var(--muted)]', className)}
      aria-hidden="true"
      {...props}
    />
  );
}
